import React from 'react';

import {labels} from '../../../../../../../util/utils';
import {ProfileDigitalGAMType} from '../../../../../../../util/uiconstants';

export const prop = 'prDigtalGam';
export const id = 'digitalAuditColumn';

const getDigitalAudit = (gamNumber) => {
	if (gamNumber === ProfileDigitalGAMType.yes) {
		return labels.yes;
	}

	if (gamNumber === ProfileDigitalGAMType.no) {
		return labels.no;
	}
};

export const config = (labels) => ({
	id,
	label: labels.digitalAuditLabel,
	propName: prop,
	width: 'minmax(var(--px-160), 1fr)',
	sortBy: prop,
	customCell: (item) => {
		return (
			<span title={getDigitalAudit(item.gAType)} className="group-role ellipsis">
				{getDigitalAudit(item.prDigtalGam)}
			</span>
		);
	}
});
